export const formatPricingDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

export const formatPricingDateRange = (start, end) => {
  if (!start && !end) return "";
  if (!end) return formatPricingDate(start);
  return `${formatPricingDate(start)} – ${formatPricingDate(end)}`;
};
